export const testRoutes = [
  {
    path: 'form-test',
    name: 'FormTest',
    meta: {
      requiresAuth: true,
    },
    component: () => import('@/views/test/FormTestView.vue'),
  },
  {
    path: 'translation-test',
    name: 'TranslationTest',
    meta: {
      requiresAuth: true,
    },
    component: () => import('@/views/test/TranslationTestView.vue'),
  },
  {
    path: 'element-test',
    name: 'ElementTest',
    meta: {
      requiresAuth: true,
    },
    component: () => import('@/views/test/ElementTestView.vue'),
  },
]
